/* ====================================
*            ANGULAR IMPORTS
======================================= */

import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* ====================================
*            PRIMENG IMPORTS
======================================= */

import { ConfirmationService } from 'primeng/api';

/* ====================================
*            CUSTOM IMPORTS
======================================= */

import { SharedUiModule } from '@app/shared/ui';

@NgModule({
  declarations: [],
  imports: [CommonModule, SharedUiModule, RouterModule],
  providers: [ConfirmationService],
  exports: [],
})
export class SharedCommonModule {}
